import { useEffect } from 'react';

export function useAddEventListener<
  K extends keyof HTMLElementEventMap,
  T extends (Window & typeof globalThis) | Document | HTMLElement | null = Document,
>(
  key: K,
  callback: (this: HTMLFormElement, ev: HTMLElementEventMap[K]) => any,
  dependencies?: unknown[],
  target?: T,
): void;
export function useAddEventListener<
  K extends keyof WindowEventMap,
  T extends (Window & typeof globalThis) | Document | HTMLElement | null = Document,
>(
  key: K,
  callback: EventListenerOrEventListenerObject,
  dependencies: unknown[] = [],
  target?: T,
): void {
  const element = target === undefined ? document : target;

  useEffect(() => {
    element?.addEventListener(key, callback);
    return () => {
      element?.removeEventListener(key, callback);
    };
  }, [element, ...dependencies]);
}
